export default {
  more: "Yana",
  freeUser: "Bepul",
  at: "at",
  days: "kun",
  serviceUnavailable: "xizmatga kirish mumkin emas",
  serviceUnavailableCapitalize: "xizmatga kirish mumkin emas",
  room: "Kabinet",
  Chief: "Rahbar",
  Admin: "Administrator",
  Manager: "Menejer",
  heading: "Xabarlarni o‘tkazib yubormang",
  text: "Bildirishnomalarni yoqing. Brauzer bildirishnomalarni yuborish uchun ruxsat so‘raydi - ruxsat bering. Shundan so‘ng, qaysi saytda bo‘lishingizdan qat’i nazar, ATI xabarlari ekranning pastki qismida paydo bo‘ladi.",
  btnText: "bildirishnomalarni yoqish",
  importantMessagesPluralize: {
    one: "muhim xabar",
    few: "muhim xabarlar",
    many: "muhim xabarlar",
    other: "muhim xabarlar",
  },
  CoWorker: "Xodim",
  score: "Hisob",
  firman: "Litsenziyalar",
  paidFor: "Gacha to‘langan",
  add: "Qo‘shish",
  extend: "Uzaytirish",
  freeAccess: "Siz bepul kirishingiz mumkin",
  licenseDescr:
    "Siz faqat bepul mashinalar va yuklarni ko‘rishingiz mumkin. Hamma narsani ko‘rish uchun litsenziyani sotib oling.",
  whatLicensed: "Litsenziyalar yana nimalarni beradi?",
  selectLicense: "Litsenziyani tanlang",
  settings: "Sozlash",
  recurrentPaymentFailed: "Avtomatik to‘lovni yechib olishning imkoni bo‘lmadi",
  moreInfo: "Batafsilroq",
  pay: "To‘lash",
  conditions: "Shartlar",
  logout: "Chiqish",
  view: "Qarang",
  readLater: "Keyinroq o‘qiyman",
  participantsSearch: "ATI a’zolarini qidirish",
  advancedSearch: "Kengaytirilgan qidiruv",
  advanced: "Kengaytirilgan",
  cannotFindFirm: "Biz bunday ishtirokchini topmadik.",
  somethingWentWrong: "Nimadir noto‘g‘ri bajarildi.",
  somethingWentWrongWithoutDot: "Nimadir noto‘g‘ri bajarildi",
  byExtendedSearch: "Kengaytirilgan qidiruvdan",
  tryUsing: "Foydalanishga harakat qiling",
  notificationSettings: "Bildirishnoma sozlamalari",
  noNewNotifications: "Yangi bildirishnomalar yo‘q",
  viewedNotifications: "O‘qib chiqilgan bildirishnomalar",
  downloadLoadsAndTrucks: "ATI Yuk va Transport yuklab oling",
  receiveNotifications:
    "Telefoningiz yoki planshetingizda yangi yuklar haqida bildirishnomalarni oling",
  forAndroid: "Android uchun",
  forIPhoneIPad: "IPhone va IPad uchun",
  markAllAsRead: "Hammasini o‘qilgan deb belgilang",
  soundOn: "Ovozni yoqish",
  soundMute: "Ovozni o‘chiring",
  loads: "Yuklar",
  transport: "Transport",
  checks: "Tekshiruvlar",
  tenders: "Tenderlar",
  news: "Yangiliklar",
  forums: "Forumlar",
  docs: "Hujjatlar",
  atiDocs: "ATI-Hujjatlar",
  tracking: "Monitoring",
  shipmentTracking: "GPS-monitoring",
  insurance: "Sug‘urta",
  ratingOfParticipants: "Reyting",
  contacts: "Kontaktlar",
  loans: "Qarzlar",
  truckmarket: "Transportni sotish",
  yourLoads: "Sizning yuklaringiz",
  addLoad: "Yuk qo‘shish",
  searchLoads: "Yuklarni toping",
  load: "Yuk",
  yourTrucks: "Sizning mashinalaringiz",
  addTruck: "Mashinani qo‘shish",
  searchTrucks: "Mashinalarni topish",
  truck: "Mashina",
  orders: "Buyurtmalar",
  ordersFromYou: "Sizdan buyurtmalar",
  ordersToYou: "Sizga berilgan buyurtmalar",
  ordersToDriver: "Заявка водителю", // !
  vehicleFleet: "Avtopark",
  drivers: "Haydovchilar",
  organizations: "Tashkilotlar",
  contractors: "Kontragentlar va shartnomalar",
  boards: "Maydonchalar",
  yourBoards: "Sizning maydonchalaringiz",
  invitationsAndApplications: "Taklifnomalar va arizalar",
  youParticipate: "Siz ishtirok etmoqdasiz",
  invitations: "Taklifnomalar",
  aboutBoards: "Maydonchalar haqida",
  yourTenders: "Sizning Tenderlaringiz",
  addTenders: "Tenderni qo‘shish",
  catalogs: "Ma’lumotnomalar",
  directionsLists: "Yo‘nalishlar ro‘yxatlari",
  companiesList: "Firmalar ro‘yxati",
  requisites: "Sizning rekvizitlaringiz",
  registration: "Registratsiya",
  toRegister: "Ro‘yxatdan o‘tish",
  login: "Kirish",
  toLogin: "kirish",
  code: "Kod",
  copied: "Nusxa ko‘chirilgan",
  cars: "Mashinalar",
  rating: "Reyting",
  veh: "Transport vositasi",
  guaranteedPayment: "Kafolatlangan to‘lov",
  daysRemaining: ["kun", "kun", "kunlar"],
  remain: ["qoldi", "qoldi"],
  paymentHaveToBeReceived: "gacha to‘lov qabul qilinishi kerak",
  paymentHadToBeReceived: "gacha to‘lov qabul qilinishi kerak edi",
  expired: "muddati o‘tgan",
  avatar: "Avatar",
  accountReplenishment: "Hisobni to‘ldirish",
  from: "dan",
  rub: "rubl",
  aMonth: "oyiga",
  profile_freeAccessTooltip:
    "Agar siz mashinalar yoki yuklarni ko'rish uchun litsenziyani aktivlashtirsangiz, quyidagilarni qilishingiz mumkin:",
  viewContactsForCarsAndCargoes:
    "Kontaktlarni transport vositalari va yuklar bo‘yicha ko‘rish",
  viewPassports:
    "Sharhlar va da’volar bilan ATI.SU ishtirokchilarining pasportlarini ko‘rish",
  yourContact: "Sizning kontaktingiz",
  noLicenseInfo:
    "Amaldagi litsenziyalar haqidagi ma’lumotlar vaqtincha mavjud emas",
  shortMonths: {
    0: "Yanvar",
    1: "Fevral",
    2: "mart",
    3: "aprel",
    4: "may",
    5: "iyun",
    6: "iyul",
    7: "avgust",
    8: "sentyabr",
    9: "oktyabr",
    10: "Noyabr",
    11: "dekabr",
  },
  januaryGen: "Yanvar",
  februaryGen: "Fevral",
  marchGen: "mart",
  aprilGen: "aprel",
  mayGen: "may",
  juneGen: "iyun",
  julyGen: "iyul",
  augustGen: "avgust",
  septemberGen: "sentyabr",
  octoberGen: "oktyabr",
  novemberGen: "Noyabr",
  decemberGen: "Dekabr",

  year: "y.",

  recommendChangingBrowser: "Brauzerini o‘zgartirishni tavsiya qilamiz",
  someSiteFeaturesMayNotWorkInThe:
    "Saytning ba’zi funktsiyalari ishlamasligi mumkin",
  thatYouAreUsing: "siz foydalanayotgan.",
  download: "Yuklab olish",
  notificationsPluralize: {
    few: "yangi bildirishnomalar",
    many: "yangi bildirishnomalar",
    one: "yangi bildirishnoma",
    other: "yangi bildirishnomalar",
  },
  messagesPluralize: {
    oneNumber: "Yangi xabar",
    fewNumbers: "yangi xabarlar",
    manyNumbers: "yangi xabarlar",
    other: "yangi xabarlar",
  },
  remainPluralize: {
    one: "qoldi",
    few: "qoldi",
    many: "qoldi",
    other: "qoldi",
  },
  daysRemainingPluralize: {
    one: "kun",
    few: "kun",
    many: "kunlar",
    other: "qoldi",
  },
  contactsByLicense: {
    one: "kontaktni qo‘shish",
    few: "kontaktni qo‘shish",
    many: "kontaktlarni qo‘shish",
    other: "kontaktni qo‘shish",
  },
  youHave: "Sizda",
  allRead: "Hammasi o‘qilgan",
  createBoard: "Platforma yarating",
  unreadNotifications: "O‘qilmagan bildirishnomalar",
  noUnreadNotifications: "O‘qilmagan bildirishnomalar yo‘q",
  notifications: "Bildirishnomalar",
  atiMessenger: "ATI Messenjer",
  viewUnread: "O‘qilmaganlarni ko‘rish",
  readAll: "Hammasini ko‘rish",
  viewAll: "Hammasini o‘qish",
  automaticPaymentEnabled: "Avtomatik to‘lov yoqilgan",
  clickBackAndTryAgain: "Orqaga bosing va qayta urinib ko‘ring.",
  back: "Orqaga",
  sorrySomethingWentWrong: "Nimadir noto‘g‘ri bajarildi.",
  loadingError: "Yuklashda xatolik.",
  addingNewLicensesWillBeAvailableAfterRenewal:
    "Yangilangandan keyin yangi litsenziyalarni qo‘shish uchun imkoniyat bo‘ladi",
  searchParticipants: "A’zolarni qidirish",
  stars: "Yulduzlar",
  refresh: "Yangilash",
  loadsOnBoards: "Platformalardagi yuklar",
  sorrySomethingWentWrongPleaseTryAgain:
    "Nimadir xato ketdi, qayta urinib ko‘ring",
  participantHasNoPaidLicenses:
    "Foydalanuvchida to‘langan litsenziyalar mavjud emas",
  anErrorHasOccurredRefreshThePage: "Xatolik yuz berdi, sahifani yangilang",
  weRecommend: "Biz tavsiya qilamiz",
  or: "yoki",
  theSiteWillWorkMoreStable: "Ularda sayt yanada barqaror ishlaydi.",
  ICantUseAnotherBrowser: "Boshqa brauzerdan foydalana olmayman",
  howToInstallAnotherBrowser: "Boshqa brauzerni qanday o‘rnatish kerak",
  tnxForVote: "Ovoz berganingiz uchun rahmat",
  confirm: "Tasdiqlash",
  resend: "Qayta yuborish",
  sendCode: "Kodni yuborish",
  cancel: "Bekor qilish",
  codeSent: "Kod yuborildi",
  codeSentOnNewEmail:
    "Yangi elektron pochta manziliga tasdiqlash kodi bilan xat yuborildi",
  resendAgain: "dan keyin qayta yuborish",
  seconds: "sek.",
  loanAvailable: "Sizda kirish imkoni mavjud",
  cargoOwnerButtonAvailable: "ATI.SU с нуля",
  youCan: "Siz",
  unsubscribeFrom: "obunani bekor qilish",
  turnPartnerOffers: "yoki barcha hamkorlar takliflarini o‘chirib qo‘ying",
  inNotificationSettings: "xabarnoma sozlamalarida",
  youCanUnsubscribeFromPartners:
    "Siz {{inSettings}} ATI.SU hamkorlarining takliflariga obunani bekor qilishingiz mumkin",

  allServices: "Barcha xizmatlar",

  automationHeader: "yuk tashuvlarni avtomatlashtirish",
  statisticHeader: "Statistika",
  securityHeader: "Xavfsizlik",
  comunicationHeader: "Muloqot",
  addInstrumentsHeader: "Qo‘shimcha vositalar",
  usefulHeader: "Foydali",

  apiLink: "API ATI.SU",
  apiLinkDescription:
    "Korporativ dasturiy ta’minotingizni ATI.SU xizmatlari bilan integratsiyalash",
  automationLink: "Avtomatlashtirish",
  gpsLink: "GPS-monitoring",
  gpsDescription:
    "Transport vositasining joylashuvi va tashish holatini onlayn kuzatib boring",
  docsLink: "ATI-Hujjatlari (Elektron hujjat aylanishi)",
  docsDescription:
    "Elektron hujjatlarni yarating va hamkorlar bilan almashing.",
  ordersLink: "Buyurtmalar",
  ordersDescription:
    "Tashishni to‘liq avtomatlashtirish - hamkorlarni qidirishdan tortib, tahlil qilishgacha",
  boardsLink: "ATI.SU Maydonchalari",
  boardsDescription:
    "Ishonchli hamkorlar bilan ishlash uchun o‘z platformangizni yarating",
  tendersLink: "Tenderlar",
  tendersDescription:
    "O‘nlab va yuzlab tashuvlar uchun uzoq muddatli shartnomalar tuzing",
  auctionLink: "Savdolar",
  auctionDescription: "Yuk uchun eng maqbul narxni toping",
  indexLink: "ATI.SU FTL RF indeksi",
  indexDescription:
    "Rossiya Federatsiyasining eng mashhur yo‘nalishlari uchun tariflar dinamikasi",
  middlePriceLink: "O’rtacha stavkalar",
  middlePriceDescription:
    "Rossiya Federatsiyasining minglab yo‘nalishlari uchun joriy tariflar rubl/km",
  cargoMapLink: "Yuklarning xaritasi",
  profitableDestinationsLink: "Foydali yo’nalishlar",
  profitableDestinationsDesription: "",
  unlimitedCheckLink: "«Reputatsiya» dan kontragentlarning cheksiz tekshirish",
  unlimitedCheckDescription:
    "Xavfsizlik signali + hisobot + Rossiya Federatsiyasi firmalari uchun kengaytirilgan tahlil",
  guaranteePaymentLink: "Yuk tashishni to’lov kafolati",
  guaranteePaymentDescription: "",
  checkLink: "ATI.SU tekshiruvlari",
  checkShortLink: "Tekshiruvlari",
  checkDescription:
    "Yuk yoki to‘lovni yo‘qotmaslik uchun yuridik shaxsni, jismoniy shaxsni yoki transport vositasini tekshiring",
  trafficLightLink: "Svetofor+",
  trafficLightDescription:
    "Xavfsizlik signali + Rossiya va Qozog‘iston firmalari haqida hisobot",
  messengerLink: "ATI Messenjer",
  messengerDescription:
    "Tashish to‘g‘risida kelishib oling, ATI.SU ishtirokchisiga fotosuratlar va hujjatlarni yuboring",
  forumsLink: "Forumlar",
  forumsDescription: "Yangiliklarni muhokama qiling, tajriba va fikr almashing",
  realTruckLink: "Faol tashuvchilarni qidiring",
  realTruckDescription:
    "Agar yuklar uzoq vaqt ketmasa, maqbul tashuvchini toping",
  distanceCalculatorLink: "Masofani hisoblash",
  distanceCalculatorDescription:
    "Yuk mashinalari uchun marshrutni rejalashtiring",
  chainsLink: "Yuk zanjirlari",
  chainsDescription: "Maksimal stavka bilan eng daromadli zanjirni yarating",
  academyLink: "ATI.SU akademiyasi",
  academyDescription: "Logistika muammolarini samarali hal qilishni o‘rganing",
  loansLink: "Qarzlar",
  loansDescription: "ATI ishtirokchilari uchun maxsus shartlar",
  newsLink: "Yangiliklar",
  newsDescription:
    "Yuk tashish olamidagi eng muhim yangiliklardan birinchi bo‘lib xabardor bo‘ling",
  partnershipLink: "Referal dastur",
  partnershipDescription:
    "Yangi foydalanuvchilarni taklif qiling va biz bilan pul ishlang",
  ratingLink: "ATI.SU ishtirokchilari reytingi",
  ratingDescription: "Mintaqangizdagi eng yaxshi ishtirokchilarni toping",
  insuranceLink: "Sug‘urta",
  insuranceDescription:
    "Bir necha marta bosish orqali yuk yoki javobgarlikni sug‘urtalang",
  truckmarketLink: "Transportni sotish",
  truckmarketDescription:
    "Transport vositalari va maxsus texnikalarni soting, sotib oling yoki ijaraga oling",
  timeSlots: "Vaqt oynalari",
  timeSlotsDescription:
    "Omborning navbatlarsiz va jarimalarsiz samarali ishlashini tashkil qilish",
  menu_billing: "ATI.SUni to'lash",
  partnersOffers: "Hamkorlarning maxsus takliflari",
  catalogsLink: "Ma’lumotnomalar",
  ticketsLink: "Murojaatlar (tiketlar)",
  courierLink: "ATI Kuryer",

  loadsSearch: "Yuklarni qidirish",
  mainMenu_loads: "Yuklar",
  trucksSearch: "Avtomobillarni qidirish",
  mainMenu_trucks: "Mashinalar",

  mainMenu_atiDocs_short: "ATI-Hujjatlar",

  cargoOwners: "Yuk egalari uchun",

  submenu_codeCopied: "Koddan nusxa olindi",

  menu_section_loadsAndOrders: "Yuklar va buyurtmalar",
  menu_addLoad: "Yuk qo‘shish",
  menu_yourLoads: "Sizning yuklaringiz",
  menu_yourTenders: "Sizning tenderlaringiz",
  menu_addTenders: "Tenderni qo‘shish",
  menu_yourOrders: "Sizdan buyurtmalar",
  menu_reports: "Hisobotlar",

  menu_section_boards: "Maydonchalar",
  menu_invitations: "taklifnomalar",
  menu_yourBoards: "Sizning maydonchalaringiz",
  menu_youParticipate: "Siz ishtirok etmoqdasiz",
  menu_createBoard: "Maydonchani yaratish",
  menu_boards: "Maydonchalar",

  menu_section_carrierSearch: "Tashuvchilarni qidirish",
  menu_trucksSearch: "Yuk tashuvchilarni qidirish",
  menu_activeCarriers: "Faol yuk tashuvchilar",
  menu_rating: "Ishtirokchilar reytingi",
  menu_safetyMemo: "Xavfsizlik eslatmasi",

  menu_section_catalogs: "Ma’lumotnomalar",
  menu_organizations: "Tashkilotlar",
  menu_partnersAndContracts: "Kontragentlar va shartnomalar",
  menu_yourRequisites: "Sizning rekvizitlaringiz",
  menu_firmLists: "Firmalar ro‘yxati",
  menu_directionLists: "Yo‘nalishlar ro‘yxatlari",
  menu_catalogs: "Sizning ma'lumotnomalaringiz",
  menu_drivers: "Haydovchilar",

  carriers: "Yuk tashuvchilar uchun",

  menu_section_trucksAndOrders: "Mashinalar va buyurtmalar",
  menu_addTruck: "Mashinani qo‘shish",
  menu_yourTrucks: "Sizning mashinalaringiz",
  menu_ordersToYou: "Sizga buyurtmalar",

  menu_section_loadsSearch: "Yuklarni qidirish",
  menu_loadsSearch: "Yuklarni qidirish",
  menu_cargoChains: "Yuk zanjirlari",
  menu_boardsSearch: "Maydonchalar",

  menu_boardsLoadsSearch: "Maydonchalardagi yuklar",

  menu_section_trucksSearch: "Tashuvchilarni qidirish",
  menu_exchange: "ATI.SU birjasi",
  menu_gps: "GPS-monitoring",

  menu_section_usefull: "Foydali",

  menu_section_yourDocuments: "Sizning hujjatlaringiz",
  menu_section_rouming: "Rouming",
  menu_section_createDocument: "Hujjatni yarating",
  menu_inbox: "Kiruvchilar",
  menu_awaitingDecision: "Qarorlar kutilmoqda",
  menu_closing: "ATI.SUdan yopilish",
  menu_yourCounterparties: "Sizning kontragentlaringiz",
  menu_yourCertificates: "Sizning Elektron Imzo (EI) sertifikatlaringiz",
  menu_invoice: "To'lov uchun hisob-faktura",
  menu_applicationAgreement: "Ariza shartnomasi",
  menu_certificateOfCompletion: "Bajarilgan ishlar akti",
  menu_otherDocument: "Boshqa hujjat",

  menu_add_order: "Haydovchiga arizani qo’shish",

  burger_addLoad: "Yuk qo‘shish",
  burger_addTruck: "Mashinani qo‘shishg",

  bottom_yourLoad: "Sizning yuklaringiz",
  bottom_loads: "Yuklar",
  bottom_yourTrucks: "Sizning mashinalaringiz",
  bottom_trucks: "Mashinalar",
  bottom_services: "Xizmatlar",
  bottom_orders: "Buyurtmalar",
  bottom_profile: "Profil",

  mainMenu_atiDocs: "ATI-Hujjatlar (EHA)",

  profile_serviceUnavailable: "xizmatga kirish mumkin emas",
  profile_freeUser: "Bepul",
  profile_atis: "at.",
  profile_days: "kun",
  profile_yourContact: "Sizning kontaktingiz",
  profile_refresh: "Yangilash",
  profile_score: "Hisob",
  profile_room: "Kabinet",
  profile_logout: "Chiqish",
  profile_freeAccess: "Siz bepul kirishingiz mumkin",
  profile_freeAccessText:
    "Siz faqat bepul mashinalar va yuklarni ko‘rishingiz mumkin. Hamma narsani ko‘rish uchun litsenziyani sotib oling.",
  profile_whatsMore: "Litsenziyalar yana nimalarni beradi?",
  profile_selectLicense: "Litsenziyani tanlang",
  profile_fromPerMonth: "oyiga 460 ₽ dan",
  profile_payBefore: "To'lash {{val}}",
  profile_guaranteedPayment: "Kafolatlangan to‘lov.",
  profile_remainPluralize: {
    one: "qoldi",
    few: "qoldi",
    many: "qoldi",
    other: "qoldi",
  },
  profile_daysRemainingPluralize: {
    one: "kun",
    few: "kun",
    many: "kunlar",
    other: "",
  },
  profile_conditions: "Shartlar",
  profile_pay: "To‘lash",
  profile_settings: "Sozlash",
  profile_automaticPaymentEnabled: "Avtomatik to'lov yoqilgan",
  profile_paidFor: "Gacha to‘langan {{val}}",
  profile_addingNewLicenses: "Yangilangandan keyin yangi litsenziyalarni",
  profile_WillBeAvailableAfterRenewal: "qo‘shish uchun imkoniyat bo‘ladi",
  profile_add_new: "Itsenziyani qo'shish",
  profile_extend: "Uzaytirish",
  profile_add: "Qo‘shish",
  profile_recurrentPaymentFailed:
    "Avtomatik to‘lovni yechib olishning imkoni bo‘lmadi",
  profile_code: "Kod",
  search_participantsSearch: "ATI.SU a’zolarini qidirish",
  search_atiParticipantsSearch: "ATI.SU a’zolarini qidirish",
  search_advancedSearch: "Kengaytirilgan qidiruv",
  search_advanced: "Kengaytirilgan",
  search_phoneAndEmailRestriction:
    "Telefon raqami va boshqa aloqa ma’lumotlari bo’yicha qidirish pullik a’zolar uchun mavjud.",
  search_pricesAndRates: "Narxlar va tariflar",

  nps_recomendChance:
    "O‘z tanishlaringizga ATI.SUni tavsiya qilish ehtimoli qanday?",
  nps_errorTryAgain:
    "Yana bir bor urinib ko‘ring. Javobni yuborishda xatolik yuz berdi.",
  nps_rateNoRecommend: "umuman tavsiya qilmayman",
  nps_rateRecommend: "albatta tavsiya qilaman",
  nps_thanksForRate: "ta javob uchun rahmat ({{val}} tadan 10)",
  nps_from: "tadan",
  nps_commentYourAnswer: "Javobga izoh bering",
  nps_send: "Yuborish",
  nps_tryAgain: "Yana bir bor urinib ko‘ring.",
  nps_errorWhileSending: "Javobni yuborishda xatolik yuz berdi.",
  nps_answerSended:
    "Javob yuborildi. So‘rovnomada ishtirok etganingiz uchun tashakkur",
  nps_youAlreadyVoted:
    "Siz allaqachon ovoz bergansiz. So‘rovnomada ishtirok etganingiz uchun tashakkur",

  security_header: "Sizningcha, ATI.SU orqali ishlash qanchalik xavfsiz?",
  security_rateNoRecommend: "umuman xavfsiz emas",
  security_rateRecommend: "mutlaqo xavfsiz",
  security_headerSuccess: "Javob uchun rahmat",
  security_headerDescription: "Xohlasangiz izoh qoldirishingiz mumkin",

  outdated_outdatedBrowserTitle: "Brauzeringiz xatolar bilan ishlashi mumkin",
  outdated_ieWasFound:
    "Brauzeringiz eskirgan. ATI.SU Birjasi xatosiz ishlashi uchun tavsiya etilgan brauzerlardan birini o'rnating:",
  outdated_outdatedBrowserWasFound:
    "Brauzeringiz versiyasi eskirgan. ATI.SU Birjasida xatosiz ishlashi uchun brauzeringizni yangilang:",
  outdated_update: "Yangilash",
  outdated_remindLater: "Keyinroq eslatish",
  outdated_howToUpdate: "Brauzerni qanday yangilash kerak",
  outdated_howToInstallAnotherBrowser: "Brauzerni qanday o'rnatish kerak",

  refresh_attemptsLimitError:
    "Превышено кол-во обновлений, повторите через 5 минут", // !
  notification_unsubscribePartnerText:
    "Siz {{val1}} qilishingiz yoki {{val2}} hamkorlarimizdan kelgan barcha takliflarni o'chirib qo'yishingiz mumkin",
  notification_unsubscribePartnerATISU:
    "ushbu ATI.SU hamkorining pochta jo'natmalaridan obunani bekor",
  notification_notificationsSettings: "xabarnoma sozlamalarida",

  feed_checkAll: "Hammasini o‘qilgan deb belgilang",
  feed_allRead: "Hammasi o‘qilgan",
  feed_showMessegesText: "Messenjer xabarlari matnini ko'rsatish",
  feed_groupedMessageCounter: {
    one: "xabar",
    few: "xabarlar",
    many: "xabarlar",
    other: "xabarlar",
  },

  mainMenu_analitics: {
    statistika_rynka: "Bozor statistikasi",
    servisy_dlya_analitiki: "Analitik xizmatlari",
    dinamika_rynka: "Bozor dinamikasi",
    rynok_v_cifrah: "Bozor raqamlarda",
  },

  menu_analitics_averageRates: "Միջին դրույքաչափեր",
  menu_analitics_cargomap: "Բեռների քարտեզ",
  menu_analitics_profitdirections: "Շահավետ ուղղություններ",
  menu_analitics_index: "Ինդեքս",


  /** Это группе строк не нужен перевод */
  languageInformer_title: "Выберите язык интерфейса",
  languageInformer_description:
    "Вы всегда сможете изменить свой выбор в кабинете или подвале сайта.",
  languageInformer_button: "Сохранить",
  /** Конец группы */
};
